export default "__VITE_ASSET__Bpf8klVR__"